import React from "react";
import { Mail, MessageCircle } from "lucide-react";
import { ORDER_EMAIL, ORDER_WHATSAPP_DISPLAY, ORDER_WHATSAPP_URL } from "@/lib/social";

import { useLang } from "@/lib/lang";

const WA_FR = encodeURIComponent("Bonjour Ozentya, je suis un professionnel et je souhaite des renseignements / passer commande. Établissement : … Ville / pays : …");
const WA_EN = encodeURIComponent("Hello Ozentya, I am a professional and I would like information / to place an order. Business: … City / country: …");

export const OrderContact = ({ intl = false, dark = false, title = "Commander ou se renseigner", className = "", testid = "order-contact" }) => {
  const { en } = useLang();
  const WA_TEXT = en ? WA_EN : WA_FR;
  return (
  <div data-testid={testid} className={className}>
    {title && <p className={`text-sm font-semibold mb-3 ${dark ? "text-white" : "text-[var(--oz-text)]"}`}>{title}</p>}
    <div className="flex flex-wrap gap-2">
      <a href={`${ORDER_WHATSAPP_URL}?text=${WA_TEXT}`} target="_blank" rel="noreferrer" data-testid={`${testid}-whatsapp`}
        className="inline-flex items-center gap-2 rounded-full bg-[#25D366] text-[#0B2E13] font-semibold text-sm px-5 py-3 min-h-[46px] hover:brightness-95 transition-[filter]">
        <MessageCircle className="w-4 h-4" /> WhatsApp {intl ? "+33 6 25 99 55 02" : ORDER_WHATSAPP_DISPLAY}
      </a>
      <a href={`mailto:${ORDER_EMAIL}?subject=${encodeURIComponent(en ? "Ozentya trade enquiry" : "Demande professionnelle Ozentya")}`} data-testid={`${testid}-email`}
        className={`inline-flex items-center gap-2 rounded-full border font-semibold text-sm px-5 py-3 min-h-[46px] transition-colors ${dark ? "border-white/30 text-white hover:border-[var(--oz-gold)]" : "border-[var(--oz-border)] hover:border-[var(--oz-dark)]"}`}>
        <Mail className="w-4 h-4" /> {ORDER_EMAIL}
      </a>
    </div>
  </div>
  );
};
